import React, { useEffect, useState, useRef, useMemo } from "react";
import Header from "../../components/Header";
import { useStores } from "../../stores";
import Slider from "react-slick";
import NoImage from "../../assets/images/noImage.jpg";
import moment from "moment";
import AccordionItem from "../../components/AccordionItem";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import leftarrow from "../../assets/images/leftarrow.png";
import rightarrow from "../../assets/images/rightarrow.png";
import { useDayPassContext } from '../../stores/DayPassContextProvider'; 
import { useNavigate } from 'react-router-dom';
import notify from "../../components/Notify/notify";
import { useLocation } from "react-router-dom";
import "./style.scss";

function DayPassBookNow() {
    const { setDayPassData, setAdditionalData } = useDayPassContext();
    
    const navigate = useNavigate(); 
    const location = useLocation();

    const [accessKey, setAccessKey] = useState("");

  const getCenterListCalled = useRef(false);
  const { bookingStore } = useStores();
  const [loader, setLoader] = useState(true);
  const [imageGallery, setImageGallery] = useState([]);
  const [bookingData, setBookingData] = useState([]);
  const [bookingValue, setBookingValue] = useState(1);
  const [selectedDate, setSelectedDate] = useState("");
  const [dataFromAPI, setDataFromAPI] = useState([]);
  const [loading, setLoading] = useState(false);

  const dateRef = useRef();
  const today = new Date();

  const date = moment(today).format("YYYY-MM-DD");
  const formattedDate = moment(today).format('ddd, D MMM, YYYY');
  const [selectedDateFormat, setSelectedDateFormat] = useState(selectedDate);
  const [openAccordionIndex, setOpenAccordionIndex] = useState(0);


  const settings = {
    dots: true,
    autoplay: true,
    autoplaySpeed: 2000,
    infinite: true,
    speed: 2000,
  };

  const state = {
    responsive: {
      0: {
        items: 1,
      },
      450: {
        items: 1,
      },
      600: {
        items: 2,
      },
      1000: {
        items: 2,
      },
    },
  };


  useEffect(() => {
    setSelectedDateFormat(formattedDate); 
  }, []);

  const getCentreDetails = async (center_id) => {
    if (getCenterListCalled.current) {
      return;
    }
    getCenterListCalled.current = true;
    await bookingStore.getCenterDeatilsDayPass(center_id, (response) => {
      if (response?.data?.status === 1) {
        setLoader(false);
        console.log("res:> ", response.data.data[0]);
        const parsedImageGallery = JSON.parse(
          response.data.data[0].image_gallery || "[]"
        );

        setImageGallery(parsedImageGallery);
        setBookingData([response.data.data[0]]);

        setAdditionalData(response.data.data[0]);
        sessionStorage.setItem('day-pass-additional-data', JSON.stringify(response.data.data[0]))


      } else {
        console.error("Error fetching center list");
      }
    });
  };

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);

    const formattedDate = moment(e.target.value).format('ddd, D MMM, YYYY');

    setSelectedDateFormat(formattedDate);
  };

  const MapContainer = ({ latitude, longitude }) => (
    <iframe
      src={`https://maps.google.com/maps?q=${latitude},${longitude}&z=15&output=embed`}
      width="100%"
      height="400"
      style={{ border: 0 }}
      loading="lazy"
      className="location-map"
    ></iframe>
  );

  useEffect(() => {
    let url = window.location.pathname;
    let access_key = url.split("/day-pass/book-now/")[1];
    setAccessKey(access_key);
  }, [window.location.pathname]);

  useEffect(() => {
    setLoader(true);
    const queryParams = new URLSearchParams(window.location.search);
    const params = parseInt(queryParams.get("center_id"), 10);
    getCentreDetails(`center_id=${params}`);
  }, []);

  useEffect(() => {
    if (!loader) {
      const minus = document.querySelector("#minus");
      const plus = document.querySelector("#plus");
      const input = document.querySelector("#input");

      let quantity = 1;

      input.value = quantity;

      minus?.addEventListener("click", function (event) {
        if (quantity > 1) {
          quantity--;
          input.value = quantity;
          setBookingValue(quantity);
        }
      });

      plus?.addEventListener("click", function (event) {
        // if (quantity === 10) {
        //   notify("Max Limit", "danger")
        //   return;
        // }
        quantity++;
        input.value = quantity;
        setBookingValue(quantity);

        console.log("quantity>> ", quantity);
      });
    }
  }, [loader]);

  useEffect(() => {
    const adjustSlickDots = () => {
      setTimeout(function () {
        const slickDotsList = document.querySelectorAll(".slick-dots");
        slickDotsList.forEach((slickDots) => {
          if (slickDots) {
            if (window.innerWidth > 768) {
              slickDots.style.top = "400px";
            } 
          }
        });
      }, 500);
    };
  
    adjustSlickDots();
  
    // Add a popstate event listener to handle back button navigation
    window.addEventListener("popstate", adjustSlickDots);
  
    return () => {
      // Clean up the popstate event listener when the component unmounts
      window.removeEventListener("popstate", adjustSlickDots);
    };
  }, [location.pathname]);
  
  

  const getCenterList = async (cityId) => {
    getCenterListCalled.current = true;
    await bookingStore.getCenterListDayPass(cityId, (response) => {
      if (response?.data?.status === 1) {
        console.log(
          "response get data from here for owl coursoul ",
          response.data
        );
        setDataFromAPI(response.data.data);
      } else {
        console.error("Error fetching center list");
      }
    });
  };


  const bookNowDayPass = async (inventory_id, qty, selectdate) => {
    setLoading(true);

    const currentURL = window.location.href;
    const accessKey = currentURL.split('/day-pass/book-now/')[1].split('?')[0];
  
    let params = `inventory_id=${inventory_id}&valid_from=${selectdate}&qty=${qty}`;
    await bookingStore.getBookNowDayPass(params, (response) => {
        if (response?.data?.status === 1) {
      
        // Set data in context
         setDayPassData(response.data.data);
         sessionStorage.setItem('day-pass-billing',JSON.stringify( response.data.data))
        
         console.log('Data after setting in context:', response.data);

         setTimeout(() => {
          setLoading(false);
        }, 2000);

        const queryParams = new URLSearchParams(window.location.search);
        const utm_source = queryParams.get("utm_source");
        const utm_medium = queryParams.get("utm_medium");
        const utm_campaign = queryParams.get("utm_campaign");

        if(utm_source || utm_medium || utm_campaign){
          sessionStorage.setItem('urlParams', `utm_source=${utm_source}&utm_medium=${utm_medium}&utm_campaign=${utm_campaign}`);
          navigate(`/day-pass/book-now/payment/${accessKey}?utm_source=${utm_source}&utm_medium=${utm_medium}&utm_campaign=${utm_campaign}`);
        }else{
          sessionStorage.removeItem('urlParams');
          navigate(`/day-pass/book-now/payment/${accessKey}`);
        }
       } else {
          setLoading(false);
          notify(response?.response?.data?.data?.message || response?.response?.data?.data[0], "danger");
        }
      });
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const cityId = queryParams.get("city_id");
    const startTime = queryParams.get("start_time");
    setSelectedDate(startTime);


    const formattedDate = moment(startTime).format('ddd, D MMM, YYYY');

    setSelectedDateFormat(formattedDate);

    let params = `city_id=${cityId}&start_time=${startTime}`;
    getCenterList(params);
  }, []);

  useEffect(() => {
    setOpenAccordionIndex(0);
  }, []);

  const handleAccordionClick = (index) => {
    if (index === openAccordionIndex) {
      setOpenAccordionIndex(null);
    } else {
      setOpenAccordionIndex(index);
    }
  };

  const mapComponent = (lat, long) => (
    <MapContainer latitude={lat} longitude={long} />
  );

  const memoizedMapComponent = useMemo(() => {
    const latitude = (bookingData[0]?.latitude) || 0;
    const longitude = (bookingData[0]?.longitude) || 0;
    return mapComponent(latitude, longitude);
  }, [bookingData]);

  return (
    <>
      <Header accessKey={accessKey} queryParams={window.location.origin + `/day-pass/${accessKey}`} dayPass={true} />
      {loader ? (
        <div className="loader"></div>
      ) : (
        <div className="col-md-14 slider-containesr">
          <div className="slider-containers">
            <Slider {...settings}>
              {imageGallery.map((item, slideIndex) => {
                return (
                  <div
                    key={slideIndex}
                    className={
                      slideIndex === slideIndex
                        ? "carousel-item active"
                        : "carousel-item"
                    }
                  >
                    <img
                      src={item || NoImage}
                      alt={`Banner ${slideIndex + 1}`}
                      className="banner-image"
                      loading="lazy"
                    />
                  </div>
                );
              })}
            </Slider>
          </div>

          <div className="booking-day-box">
            <div className="row align-items-center">
              <div className="col-md-6">
                <div className="booking-detail-box-inner">
                  <div className="booking-detail-text">
                    <h3 className="booking-detail-heading">
                      {bookingData.length > 0 && bookingData[0].name}
                    </h3>
                    <p className="booking-sub-heading">
                      {bookingData.length > 0 && bookingData[0].address}
                    </p>
                    {/* <p className="booking-sub-heading">
                     {bookingData[0].location_name}
                    </p> */}
                    
                    <h4 className="price-book-now">
                      {bookingData.length > 0 &&
                        `Rs ${parseInt(
                          bookingData[0].price_per_seat_per_day
                        )}/Day`}
                    </h4>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="price-total-box">
                  <div className="row form-row align-items-center">
                    <div className="col-md-6 col-6">
                      <div
                        className="date-box form-group icon-group"
                        onClick={() => {
                          dateRef.current.showPicker();
                        }}
                      >
                        <div>
                          {/* <img
                            src={DateIcon}
                            alt="Location"
                            className="map-icon"
                          /> */}
                          <input
                            ref={dateRef}
                            className="form-control filter-field date"
                            value={selectedDate}
                            onChange={handleDateChange}
                            type="date"
                            min={date}
                          />
                          <span className="open-button-day-pass">
                            <img
                              src={require("../../assets/images/down.png")}
                              alt="Date"
                              className="date-icon"
                            />
                          </span>
                          <p class="date-home-book-now">{selectedDateFormat}</p>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6 col-6">
                      <div class="control form-group">
                        <button class="bttn bttn-left" id="minus">
                          <span>-</span>
                        </button>
                        <input type="number" class="input" id="input" />
                        <button class="bttn bttn-right" id="plus">
                          <span>+</span>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="total-text-box">
                    <div className="total-text">
                      <h3 className="total-text-day-pass">TOTAL</h3>
                      <h4 className="total-price">
                        {`Rs ${
                          bookingData[0].price_per_seat_per_day * bookingValue
                        }`}{" "}
                      </h4>
                    </div>
                    <div className="total-text-btn">

                    <div className={`book-slot-btn-day-pass ${loading ? 'loading' : ''}`}  onClick={() => bookNowDayPass(bookingData[0].inventory_id, bookingValue, selectedDate)} disabled={loading}>
                    {loading ? (
                      <div className="spinner"></div>
                    ) : 'BOOK NOW'}
                  </div>
    
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6  no-gutters">
              <div className="faq-box-day-pass">
                <div className="accordion" id="accordionExample">
                  {/* Use AccordionItem component */}
                  <AccordionItem
                      title="Location Highlights"
                      isOpenByDefault={true}
                      onAccordionClick={() => handleAccordionClick(0)}
                      isOpen={openAccordionIndex === 0}
                    >
                      {bookingData[0]?.location_highlight}
                    </AccordionItem>

                    <AccordionItem
                      title="Best in Class Service"
                      isOpenByDefault={false}
                      onAccordionClick={() => handleAccordionClick(1)}
                      isOpen={openAccordionIndex === 1}
                    >
                      {bookingData[0]?.service_info}
                    </AccordionItem>
                </div>
              </div>
            </div>
            <div className="col-md-6  no-gutters">
              <div className="map-box-day-pass">{memoizedMapComponent}</div>
            </div>
          </div>

          <section className="like-section-day-pass">
            <h3 className="section-heading-day-pass">You may also like</h3>
            <div className="section-box-day-pass">
              <OwlCarousel
                className="owl-theme"
                loop
                autoplay
                smartSpeed={150}
                autoplayTimeout={3000}
                responsive={state.responsive}
                nav={window.innerWidth > 600}
                margin={20}
                navText={[
                  `<img src=${leftarrow} class="like-nav-left-day-pass">`,
                  `<img src=${rightarrow} class="like-nav-right-day-pass">`,
                ]}
                items={1} 
                autoWidth={false} 
                stagePadding={0} 
                key={Math.random()}
              >
                {dataFromAPI.map((item, index) => (
                  <div key={item.id} className="item-day-pass"
                  onClick={() => {
                    {console.log("data from API:>> ", item)}

                    getCenterListCalled.current = false;

                    getCentreDetails(`center_id=${item.id}`);

                    window.scrollTo({
                      top: 0,
                      left: 0,
                      behavior: "smooth",
                    });
                  }}
                  >
                    <img
                      src={
                        item.image_gallery && JSON.parse(item.image_gallery).length > 0
                          ? JSON.parse(item.image_gallery)[index % JSON.parse(item.image_gallery).length]
                          : NoImage
                      }
                      alt="Banner"
                      className="section-image-day"
                    />
                    <h3 className="like-title">{item.name}</h3>
                  </div>
                ))}
              </OwlCarousel>
            </div>
          </section>
        </div>
      )}
    </>
  );
}

export default DayPassBookNow;
